module.exports = __webpack_public_path__ + "img/british-columbia.d8a19e34.svg";